import sendToClientAnalytics from '@stencil/client-side-analytics/src/send-to-client-analytics';

export default function chunkedResponseUsingIframe(id, url, dispatch, callback, timeDelay, origin) {
  const previousIframe = document.getElementById(id);
  if (previousIframe) {
    previousIframe.remove();
    window.removeEventListener('message', onMessage);
  }
  const iframe = document.createElement('iframe');
  document.body.appendChild(iframe);
  iframe.setAttribute('id', id);
  iframe.setAttribute('title', 'Search Result');
  iframe.setAttribute('scrolling', 'no');
  iframe.setAttribute('width', '0');
  iframe.setAttribute('height', '0');
  iframe.setAttribute('marginHeight', '0');
  iframe.setAttribute('marginWidth', '0');
  iframe.setAttribute('frameBorder', '0');

  window.addEventListener('message', onMessage);
  iframe.setAttribute('src', url);

  function onMessage(event) {
    const frames = document.getElementsByTagName('iframe');
    let eleId = '';
    for (let i = 0; i < frames.length; i++) {
      if (frames[i].contentWindow === event.source) {
        eleId = frames[i].id;
        break;
      }
    }
    if (eleId === id) {
      // BECAUSE CHUNKS ARE BEING RECEIVED IMMEDIATELY ONE AFTER ANOTHER
      // REACT IS BATCHING THE VIEW UPDATES
      // SO A DELAY HAS TO BE APPLIED TO EACH CHUNK'S PROCESS SO THAT
      // BATCHING DOESNOT OCCUR AND CHANGES GETS REFLECTED IMMEDIATELY
      if (event.data[0] === 0 || event.data.client_err) {
        window.removeEventListener('message', onMessage);
        // document.body.removeChild(iframe);
      }
      if (event.data.client_err) {
        sendToClientAnalytics({
          apiName: 'thor_iframe_chunked_response',
          serviceApp: 'aerial',
          clientErr: true,
          error_msg: event.data.client_err,
          origin
        });
      }
      if (timeDelay) {
        const time = event.data.n ? 200 * event.data.n[9] : 200;
        setTimeout(() => {
          dispatch(callback(event.data));
        }, time);
      } else {
        dispatch(callback(event.data));
      }
    }
  }
}
